"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAppointmentConflictsUiSchema = exports.makeAppointmentUiSchema = exports.makeAppointmentSchema = void 0;
var schema_1 = require("./appointment/schema");
Object.defineProperty(exports, "makeAppointmentSchema", { enumerable: true, get: function () { return schema_1.makeAppointmentSchema; } });
var uiSchema_1 = require("./appointment/uiSchema");
Object.defineProperty(exports, "makeAppointmentUiSchema", { enumerable: true, get: function () { return uiSchema_1.makeAppointmentUiSchema; } });
Object.defineProperty(exports, "makeAppointmentConflictsUiSchema", { enumerable: true, get: function () { return uiSchema_1.makeAppointmentConflictsUiSchema; } });
